import { IOTSimRegistrationImpl } from "features/iotSimRegistration/data/IOTSimRegistrationImpl";
import { IIOTSimRegistrationRepository } from "features/iotSimRegistration/domain/repositories/IIOTSimRegistrationRepository";
import { IOTSimRegistrationUseCase } from "features/iotSimRegistration/domain/useCases/IOTSimRegistrationUseCase";
import { IOTSimRegistrationViewModel } from "features/iotSimRegistration/presentation/viewModel/IOTSimRegistrationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class IOTSimRegistrationInjection extends InjectionModule {
  private static readonly iotSimRegistrationRepositoryToken = Symbol(
    "IIOTSimRegistrationRepository",
  );
  private static readonly iotSimRegistrationViewModelToken = Symbol(
    "IOTSimRegistrationViewModel",
  );
  private static readonly iotSimRegistrationUseCaseToken = Symbol(
    "IOTSimRegistrationUseCase",
  );

  protected static bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.iotSimRegistrationRepositoryToken,
      useClass: IOTSimRegistrationImpl,
    },
    {
      scope: "otherRepo",
      token: this.iotSimRegistrationUseCaseToken,
      useClass: IOTSimRegistrationUseCase,
    },
    {
      scope: "viewModel",
      token: this.iotSimRegistrationViewModelToken,
      useClass: IOTSimRegistrationViewModel,
    },
  ];

  static getIOTSimRegistrationRepo(): IIOTSimRegistrationRepository {
    return this.resolve(this.iotSimRegistrationRepositoryToken);
  }

  static getIOTSimRegistrationUseCase(): IOTSimRegistrationUseCase {
    return this.resolve(this.iotSimRegistrationUseCaseToken);
  }
}
